const VPN_IMG =
  "https://public.readdy.ai/ai/img_res/b364d173e53891fb28dd1fb5123979cd.jpg";

const CLEANER_IMG =
  "https://readdy.ai/api/search-image?query=iPhone%20storage%20cleaner%20optimization%20app%20concept%20sparkle%20clean%20interface%20abstract%20visualization%20warm%20amber%20orange%20gradient%20background%20minimalist%20digital%20art%20clean%20files%20removal%20concept%20modern%20iOS%20app%20visual%20no%20text%20no%20people&width=600&height=420&seq=zarev-cleaner-product-001&orientation=landscape";

interface ProductCardProps {
  image: string;
  icon: string;
  tag: string;
  title: string;
  description: string;
  accentFrom: string;
  accentTo: string;
  features: string[];
}

function ProductCard({
  image,
  icon,
  tag,
  title,
  description,
  accentFrom,
  accentTo,
  features,
}: ProductCardProps) {
  return (
    <div className="relative rounded-3xl overflow-hidden flex flex-col h-full bg-white border border-gray-100">
      {/* Image area */}
      <div
        className="w-full relative overflow-hidden"
        style={{ height: 260 }}
      >
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top"
        />
        <div
          className={`absolute inset-0 bg-gradient-to-tr ${accentFrom} ${accentTo} opacity-60`}
        />
        {/* Icon & Tag */}
        <div className="absolute inset-0 flex flex-col items-start justify-end p-8">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/20 backdrop-blur-sm">
              <i className={`${icon} text-white text-2xl`} />
            </div>
            <span className="text-white/80 text-xs font-semibold uppercase tracking-widest bg-white/10 px-3 py-1 rounded-full">
              {tag}
            </span>
          </div>
          <h3 className="text-3xl font-bold text-white">{title}</h3>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col gap-5 p-8 flex-1">
        <p className="text-gray-600 text-base leading-relaxed">{description}</p>
        <ul className="flex flex-col gap-3 mt-auto">
          {features.map((f) => (
            <li key={f} className="flex items-center gap-3 text-sm text-gray-700">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-teal-500 text-base" />
              </div>
              {f}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-32 bg-white">
      <div className="max-w-screen-xl mx-auto px-8">
        {/* Header */}
        <div className="flex justify-center mb-4">
          <span className="text-xs uppercase tracking-widest font-semibold text-teal-600 bg-teal-50 px-4 py-1.5 rounded-full">
            Our Products
          </span>
        </div>
        <h2 className="text-center text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Applications That Matter
        </h2>
        <p className="text-center text-gray-500 text-lg mb-16 max-w-xl mx-auto">
          Purpose-built for iOS, our apps deliver real value through thoughtful
          engineering and refined design.
        </p>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          <ProductCard
            image={VPN_IMG}
            icon="ri-shield-keyhole-line"
            tag="Privacy & Security"
            title="VPN"
            description="A high-performance VPN application crafted for iOS users who value their digital privacy. Enjoy fast, encrypted connections that protect your data on any network — public or private."
            accentFrom="from-teal-700"
            accentTo="to-emerald-600"
            features={[
              "Military-grade AES-256 encryption",
              "Zero-log privacy policy",
              "Seamless iOS integration",
              "Lightning-fast secure connections",
            ]}
          />
          <ProductCard
            image={CLEANER_IMG}
            icon="ri-smartphone-line"
            tag="Performance & Storage"
            title="Cleaner"
            description="A powerful iOS cleaner that reclaims storage space and boosts device performance. Intelligently identifies and removes redundant files, freeing up your iPhone so it runs like new."
            accentFrom="from-amber-500"
            accentTo="to-orange-500"
            features={[
              "Smart duplicate file detection",
              "Photo & video cache cleanup",
              "Real-time storage analysis",
              "One-tap deep device optimization",
            ]}
          />
        </div>
      </div>
    </section>
  );
}
